// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9q-4";
export var collapsed = "_9q-1";
export var headerBar = "_9q-0";
export var leftHeaderContent = "_9q-3";
export var subjectContainer = "_9q-2";